import React from "react";
import {
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  const linkColor = useColorModeValue("orange.400", "orange.200");

  return (
    <Flex
      zIndex='3'
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "center",
      }}
      justifyContent='center'
      px={{ base: "30px", md: "50px" }}
      pb='30px'>
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}>
        {" "}
        <Text as="span" fontWeight="500" ms="4px">
          Fort Fitness Malta All Rights Reserved - Developed and Maintained by{" "}
          <Text
            as="a"
            href="http://axxsky.com/"
            target="_blank"
            rel="noopener noreferrer"
            color={linkColor}
          >
            Axxsky
          </Text>
        </Text>
      </Text>
    </Flex>
  );
}
